"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonContainer = exports.SkeletonBox = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const shimmerAnimation = (0, _styledComponents.keyframes)`
  100% {
    transform: translateX(100%);
  }
`;
const SkeletonBox = exports.SkeletonBox = _styledComponents.default.div`
	${({
  height,
  width,
  type,
  bgColor
}) => {
  return (0, _styledComponents.css)`
			display: inline-block;
			height: ${height};
			position: relative;
			overflow: hidden;
			background-color: ${bgColor};
			width: ${width};
			border-radius: ${type === 'CIRCLE' ? '50%' : '4px'};
			max-width: 100%;
			&::after {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				transform: translateX(-100%);
				background-image: linear-gradient(
					90deg,
					rgba(255, 255, 255, 0) 0,
					rgba(255, 255, 255, 0.2) 20%,
					rgba(255, 255, 255, 0.5) 60%,
					rgba(255, 255, 255, 0)
				);
				animation: ${shimmerAnimation} 2s infinite;
				content: '';
			}
		`;
}}
`;
const SkeletonContainer = exports.SkeletonContainer = _styledComponents.default.div`
	width: 100%;
`;